<template>
  <v-container fluid>
    <v-form ref="form" v-model="valid" lazy-validation>
      <!-- Información del pago -->
      <v-card class="mb-3 pa-2" outlined>
        <v-card-title class="subtitle-1 font-weight-bold pt-0">
          Información del pago
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <!-- -----fechas----- -->
           <v-col md="3" sm="6">
            <v-row>
              <v-col  md="6" class="pr-0">
                <v-menu v-model="menu2" :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="datePay"
                      label="Fecha de pago"
                      prepend-inner-icon="mdi-calendar"
                      outlined dense hide-details
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker v-model="datePay" @input="menu2 = false"/>
                </v-menu>
              </v-col>
              <v-col  md="6" class="pl-1">
                <v-menu v-model="menu1" :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateAccount"
                      label="Fecha contable"
                      prepend-inner-icon="mdi-calendar"
                      readonly hide-details
                      outlined dense
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker v-model="dateAccount" @input="menu1 = false"/>
                </v-menu>
              </v-col>
            </v-row>
           </v-col>
             <!-- -----moneda y tasaa----- -->
           <v-col md="3" sm="6">
            <v-row>
             <v-col md="5" class="pr-0">
              <v-autocomplete
                 dense
                return-object
                outlined hide-details
                v-model="selectedCurrecies"
                @change="updatePriceCurrency"
                :items="currencies"
                label="Moneda"
                :rules="[(v) => !!v || 'Moneda es requerida']"
                color="cyanText"
                prepend-inner-icon="attach_money"
                item-text="code"
                item-value="id"
                required
              />
            </v-col>
            <v-col md="7" class="pl-1">
              <v-text-field
                v-model="currency_rate"
                label="Tasa" type="number" :min="1" step="0.01"
                hide-details :disabled="selectedCurrecies==null"
                outlined dense @change="set_new_currency_rate"
                prepend-inner-icon="currency_exchange"
              />
            </v-col>
            </v-row>
           </v-col>

            <v-col  md="2">
              <v-autocomplete
                v-model="selectedPayments"
                :items="payments"
                item-text="name" :rules="[(v) => !!v || 'Moneda es requerida']"
                item-value="id" :disabled="selectedCurrecies==null"
                label="Método de pago"
                prepend-inner-icon="mdi-credit-card-outline"
                outlined dense @change="get_prepayments()"
                required hide-details
              />
            </v-col>
            <v-col md="4">
              <v-row>
                <v-col  md="8">
                  <v-autocomplete
                    v-model="selectedAccontBank"
                    :items="bank_account_with_currency"
                    item-text="account_name"
                    item-value="account_id"
                    label="Cuenta de banco"
                    prepend-inner-icon="mdi-bank"
                    outlined dense :disabled="selectedCurrecies==null"
                    required hide-details
                  />
                </v-col>
                <v-col md="4" class="pl-0">
                  <v-text-field 
                    v-model="bank_comision"
                    type="number" min="0"
                    label="Monto comisión" hide-details
                    outlined dense :disabled="type!=2"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col md="6">
              <v-row>
                   <v-col md="3" class="pr-0 py-1">
                      <v-text-field 
                        v-model="check_number"
                        type="number"
                        label="Check Number" hide-details
                        outlined dense
                      />
                    </v-col>
                    <v-col md="9" class="pr-1 py-1">
                      <v-textarea
                        v-model="note"
                        label="Nota" hide-details
                        outlined dense rows="1"
                        prepend-inner-icon="mdi-note-text"
                      />
                    </v-col>
              </v-row>
            </v-col>           
            <v-col  md="3" class="px-1 py-1">
                <v-autocomplete
                  v-model="chart_of_account_id"
                  :items="accounts"
                  label="Cuenta contable a ennviar el excedente"
                  dense hide-details :disabled="surplus==0"
                  outlined readonly
                />
              </v-col>
            <v-col md="3" align="end" class="py-1">
              <v-row align="center" v-if="type==2">
                <v-col md="12" align="end" class="py-0"> 
                  <span class="subtitle-1 font-weight-bold mr-2">Faltante: </span>
                  <span class="subtitle-2 font-weight-bold red--text" v-if="missing > 0"> 
                    {{ currencyFormat(missing) }} {{ selectedCurrecies?.code }}
                  </span>
                  <span class="subtitle-2 font-weight-bold green--text" v-else>
                    0.00
                  </span>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col md="12" align="end"  class="py-0">
                  <span class="subtitle-1 font-weight-bold mr-2">Excedente: </span>
                  <span class="subtitle-2 font-weight-bold red--text" v-if="surplus > 0"> 
                    {{ currencyFormat(surplus) }} {{ selectedCurrecies?.code }}
                  </span>
                  <span class="subtitle-2 font-weight-bold green--text" v-else>
                    0.00
                  </span>
                </v-col>
              </v-row>
              </v-col>
          </v-row>
        </v-card-text>
      </v-card>
        <v-row align="center" justify="center" class="my-2" v-if="available_to_pay.amount_to_pay>0">
              <v-col md="3" class="py-0" align="center">
                <v-card outlined class="pa-1">
                  <span>Facturas Seleccionadas: {{ available_to_pay.selected_quantity }}</span>
                </v-card>
              </v-col>
              <v-col md="3" class="py-0" align="center">
                <v-card outlined class="pa-1">
                  <span>Monto Seleccionado: {{ currencyFormat(available_to_pay.pendingAmountTotal) }}</span>
                </v-card>
              </v-col>
              <v-col md="3"  align="center" justify="center" class="py-0">
                <v-card outlined class="pa-1">
                  <v-row align="center" justify="center"> 
                      <v-col cols="6" class="pr-1 py-0 my-0" align="right">
                        <label>Monto disponible: </label>
                      </v-col>
                      <v-col cols="4" class="pl-0 py-1 my-1">
                        <v-text-field
                          :value="available_to_pay.amount_to_pay"
                          dense type="number"
                          :min="1"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                </v-card>
              </v-col>
              <v-col md="3"  align="center" class="py-0">
                <v-card outlined class="pa-1">
                  <span :class="`${available_to_pay.color}--text`">Monto restante: {{ currencyFormat(available_to_pay.amount_to_pay-final_total_to_pay) }}</span>
                </v-card>
              </v-col>
            </v-row>
      <!-- Facturas seleccionadas -->
      <v-card class="mb-6 pa-0" outlined>
        <v-card-title class="subtitle-1 font-weight-bold">
          Facturas seleccionadas
          <v-spacer></v-spacer>
          <span class="subtitle-1 font-weight-bold mr-2">Total a pagar: </span>
          <span class="title font-weight-bold green--text">
            {{ currencyFormat(final_total_to_pay) }} {{ newInvoices[0].currency_code }}
          </span>
         <v-spacer></v-spacer>
             <v-tooltip bottom :disabled="!blockByMissingAccount">
               <template v-slot:activator="{ on, attrs }">
                 <span v-bind="attrs" v-on="on">
                   <v-btn
                     v-if="blockByMissingAccount"
                     :loading="loadingSuppliers"
                     color="warning"
                     rounded class="mr-2"
                     @click="refreshAllSupplierAccounts"
                   >
                     <v-icon left>mdi-refresh</v-icon>
                     Refrescar cuentas
                   </v-btn>
                   <v-btn
                     :loading="loadingSave"
                     color="primary"
                     rounded
                     :disabled="blockByMissingAccount"
                     @click="save"
                   >
                     <v-icon left>mdi-content-save</v-icon>
                     Procesar pago
                   </v-btn>
                 </span>
               </template>
               <span>Hay suplidores sin cuenta de banco registrada</span>
             </v-tooltip>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="newInvoices"
          :items-per-page="100"
          dense  height="43vh"
          class="elevation-1"
          fixed-header
        >
          <template v-slot:[`item.invoice_number`]="{ item }">
            <span class="blue--text font-weight-medium" style="cursor: pointer" @click="showInvoice(item.invoice_id, true)">
              {{ item.invoice_number }}
            </span>
          </template>

          <template v-slot:[`item.entity_name`]="{ item }">
            <span class="d-inline-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small class="mr-1"
                    :color="supplierAccounts[item.entity_id] ? 'green' : 'red'"
                    v-bind="attrs" v-on="on"
                  >mdi-bank</v-icon>
                </template>
                <span>{{ supplierAccounts[item.entity_id] ? 'Cuenta de banco registrada' : 'Sin cuenta de banco' }}</span>
              </v-tooltip>
              <span :class="supplierAccounts[item.entity_id] ? '' : 'red--text font-weight-medium'">
                {{ item.entity_name }}
              </span>
            </span>
          </template>

          <template v-slot:[`item.pending_amount`]="{ item }">
            <!-- <v-chip color="red lighten-4" text-color="red darken-2" small v-if="selectedCurrecies?.id !== item.original_currency_id">
            {{ selectedCurrecies?.id }} - {{ item.original_currency_id }} / {{ currencyFormat(item.original_pending_amount) }} {{ item.original_currency_code }}
            </v-chip> -->
            <v-chip color="red lighten-4" text-color="red darken-2" small >
              {{ currencyFormat(item.pending_amount) }} {{ item.currency_code }}
            </v-chip>
          </template>

          <template v-slot:[`item.total_amount`]="{ item }">
            <span>
              {{ currencyFormat(item.total_amount) }} {{ item.original_currency_code }}
            </span>
          </template>
          <template v-slot:[`item.total_paid`]="{ item }">
            <span>
              {{ currencyFormat(item.total_paid) }} {{ item.original_currency_code }}
            </span>
          </template>
          <template v-slot:[`item.total_to_pay`]="{ item }">
            <span class="green--text">
              {{ currencyFormat(item.total_to_pay) }} {{ item.currency_code }}
            </span>
          </template>

          <template v-slot:[`item.pre_payment`]="{ item }">
                <v-menu bottom origin="center center" transition="scale-transition" :disabled="prepayments_computed.length==0" :close-on-content-click="false" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.prepayment ? 'green lighten-4' : 'grey lighten-3'"
                        :text-color="item.prepayment ? 'green darken-2' : 'grey darken-1'"
                        small class="prepayment-chip"
                      >
                        <v-icon small left>{{ item.prepayment ? 'mdi-check-circle' : 'mdi-cash-plus' }}</v-icon>
                        ${{ currencyFormat(item.paid || 0) }}
                        <v-icon small right>mdi-chevron-down</v-icon>
                      </v-chip>
                    </template>

                    <v-card class="prepayment-dropdown" width="420">
                      <v-card-title class="py-2 px-3 subtitle-2 grey lighten-4">
                        <v-icon small class="mr-1">mdi-cash-multiple</v-icon>
                        Prepagos disponibles
                        <v-spacer></v-spacer>
                        <v-btn x-small color="primary" text @click="apply_prepayment_to_all(prepayments_computed[0])" v-if="prepayments_computed.length==1" class="text-none">
                          <v-icon x-small left>mdi-playlist-check</v-icon>
                          Aplicar a todas
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-list dense class="py-0" style="max-height: 300px; overflow-y: auto;">
                        <template v-for="(payment, idx) in prepayments_computed">
                          <v-list-item
                            :key="payment.id"
                            @click="asing_prepayment(item, payment)"
                            :disabled="payment.total_amount <= 0"
                            class="prepayment-item"
                            :class="{ 'prepayment-item--active': item.prepayment?.id === payment.id }"
                          >
                            <v-list-item-icon class="mr-2 my-auto">
                              <v-icon :color="payment.total_amount > 0 ? 'green' : 'grey'" small>
                                {{ item.prepayment?.id === payment.id ? 'mdi-checkbox-marked-circle' : 'mdi-circle-outline' }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="body-2 font-weight-medium">
                                {{ payment.note || 'Sin descripción' }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="caption">
                                {{ payment.created_at }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action class="my-auto ml-2" style="flex-direction: column; align-items: flex-end; gap: 2px;">
                              <v-chip
                                :color="payment.total_amount > 0 ? 'green lighten-4' : 'red lighten-4'"
                                :text-color="payment.total_amount > 0 ? 'green darken-2' : 'red darken-2'"
                                small label
                              >
                                ${{ currencyFormat(payment.original_amount) }} {{ selectedCurrecies?.code }}
                              </v-chip>
                              <span class="caption" :class="payment.total_amount > 0 ? 'green--text darken-2' : 'red--text'">
                                Disponible: ${{ currencyFormat(payment.total_amount) }}
                              </span>
                            </v-list-item-action>
                            <v-list-item-action class="my-auto ml-1" v-if="prepayments_computed.length > 1">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon x-small v-bind="attrs" v-on="on" @click.stop="apply_prepayment_to_all(payment)" :disabled="payment.total_amount <= 0">
                                    <v-icon x-small>mdi-playlist-check</v-icon>
                                  </v-btn>
                                </template>
                                <span>Aplicar a todas las facturas</span>
                              </v-tooltip>
                            </v-list-item-action>
                          </v-list-item>
                          <v-divider :key="'d-'+payment.id" v-if="idx < prepayments_computed.length - 1"></v-divider>
                        </template>
                      </v-list>
                    </v-card>
                  </v-menu>
          </template>
          <template v-slot:[`item.paid`]="{ item }">
            <v-text-field
              v-model="item.paid" 
              :disabled="disabled_paid_prepayment(item)"
              :max="max_amount_to_pay(item)"
              type="number" 
              prefix="$"  
              class="rounded-lg my-1"
              dense outlined hide-details 
              @change="change_amount_paid(item)"
              @input="updatePaidBase(item)"
            />
          </template>
          <template v-slot:[`item.settings`]="{ item }">
            <v-menu bottom left origin="top right" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-badge color="red" overlap dot :value="item.send_missing">
                  <v-btn v-bind="attrs" v-on="on" icon small>
                    <v-icon small>mdi-cog-outline</v-icon>
                  </v-btn>
                </v-badge>
              </template>

              <v-card width="360" class="settings-dropdown">
                <v-card-title class="py-2 px-3 subtitle-2 grey lighten-4">
                  <v-icon small class="mr-1">mdi-tune</v-icon>
                  Opciones de factura
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense class="py-0">
                  <!-- Cuenta de banco del suplidor a la que se paga esta factura -->
                  <template v-if="type == 1">
                    <v-subheader class="px-3 caption" style="height: 30px">
                      <v-icon x-small class="mr-1">mdi-bank</v-icon>
                      Cuenta de banco del suplidor
                    </v-subheader>
                    <template v-if="(supplierAccountsList[item.entity_id] || []).length">
                      <v-list-item
                        v-for="acc in supplierAccountsList[item.entity_id]"
                        :key="acc.account_id"
                        @click="$set(item, 'supplier_account_id', acc.account_id)"
                      >
                        <v-list-item-icon class="mr-2 my-auto">
                          <v-icon
                            small
                            :color="item.supplier_account_id === acc.account_id ? 'primary' : 'grey'"
                          >
                            {{ item.supplier_account_id === acc.account_id ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 font-weight-medium">
                            {{ acc.bank_description_long }}
                            <v-chip
                              v-if="acc.is_default"
                              x-small color="green lighten-4" text-color="green darken-2"
                              class="ml-1"
                            >Default</v-chip>
                          </v-list-item-title>
                          <v-list-item-subtitle class="caption">
                            Cta. {{ acc.account }} · {{ acc.account_name || item.entity_name }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <v-list-item v-else>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption red--text">
                          Sin cuenta de banco registrada
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 font-weight-medium">Enviar faltante a pérdida</v-list-item-title>
                      <v-list-item-subtitle class="caption">
                        {{ currencyFormat(get_missing_amount(item)) }} {{ selectedCurrecies?.code }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-switch
                        disabled
                        v-model="item.send_missing"
                        inset dense hide-details
                      ></v-switch>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    :disabled="newInvoices.length <= 1"
                    @click="removeFromList(item)"
                    class="settings-delete-item"
                  >
                    <v-list-item-icon class="mr-2 my-auto">
                      <v-icon small :color="newInvoices.length <= 1 ? 'grey' : 'error'">mdi-delete-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title
                      class="body-2 font-weight-medium"
                      :class="newInvoices.length <= 1 ? 'grey--text' : 'error--text'"
                    >
                      Eliminar factura
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-form>
  </v-container>
</template>


<script>
import { data } from "jquery";
import moment, { min } from "moment";

export default {
  data: (vm) => ({
    valid: true,
    loading: false,
    selectedCurrecies: null,
    note: null,
    currency_rate: 1,
    discount_bank: 0,
    selected_accounting: null,
    currencies: [],
    pre_payment_selected:null,
    accounts: [],
    chart_of_account_id: null,
    dateAccount: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    datePay: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    dates_accounting: {
      start_date: "",
      end_date: "",
    },
    menu1: false,
    menu2: false,
    loadingSave: false,
    newInvoices: [],
    headers: [
      { text: "Factura", value: "invoice_number", align: "start" },
      // {
      //   text: "Factura Suplidor",
      //   value: "supplier_invoice_number",
      //   align: "start",
      // },
      { text: "Entidad", value: "entity_name", align: "center" },
      { text: "Total factura", value: "total_amount", align: "end" },
      { text: "Total Pagado", value: "total_paid", align: "end" },
      { text: "Total a pagar ", value: "total_to_pay", align: "end" },

      // { text: "Notas de credito", value: "total_credit_amount", align: "end" },

      {
        text: "Balance pendiente",
        value: "pending_amount",
        align: "end",
      },

      { text: "Pre pago", value: "pre_payment", align: " d-none", width: "15%" },
      { text: "Monto abono", value: "paid", align: "center", width: "15%" },
      { text: "", value: "settings", align: "center", width: "5%" },
    ],
    search: "",
    payments: [],
    selectedPayments: null,
    check_number:null,
    bank_comision:0,
    prepayments: [],
    accountBank: [],
    selectedAccontBank: null,
    supplierAccounts: {},
    supplierAccountsList: {},
    loadingSuppliers: false,
  }),

  props: {
    data: {
      type: Array,
      default: () => [],
    },
    available_to_pay: {
      type: Object,
      default: () => { return { amount: 0, color: "green",amount_to_pay:0,pendingAmountTotal:0,selected_quantity:0 }; },
    },
    type: {
      type: Number,
    },
  },
  created() {
    this.chart_of_account_id = this.type==1?572:565;
    this.getData();
  },
  watch: {
    dateAccount(val) {
      this.getCurrencies(val);
    },
    data: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.initializeOriginalValues();
        }
      },
      immediate: true,
    },
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    bank_account_with_currency() {
      return this.accountBank.filter(
        (element) => element.currency_id == this.selectedCurrecies?.id
      );
    },
    prepayments_computed(){
      const prepaiments = [];
      const invoices = this.newInvoices.filter((element)=>element.prepayment!=undefined);

      for(let item of this.prepayments){
        const inv_pay = invoices.filter((element)=>element.prepayment.id==item.id);
        let consumido = 0;
          inv_pay.forEach(payment => {
            consumido += parseFloat(payment.paid);
          });
          prepaiments.push({...item, original_amount: parseFloat(item.total_amount), total_amount: parseFloat(item.total_amount)-consumido})
      }
      return prepaiments;
    },
    hasSupplierWithoutAccount() {
      const uniqueEntityIds = [...new Set((this.newInvoices || []).map((i) => i.entity_id))];
      return uniqueEntityIds.some((id) => !this.supplierAccounts[id]);
    },
    isTransferPayment() {
      return this.selectedPayments === 4;
    },
    blockByMissingAccount() {
      return this.type === 1 && this.isTransferPayment && this.hasSupplierWithoutAccount;
    },
    surplus(){
      let surplus = 0;
      for(let item of this.newInvoices.filter((element)=>parseFloat(element.paid) > parseFloat(element.pending_amount))){
          surplus+=parseFloat(item.paid) - parseFloat(item.pending_amount);
      }
      return surplus;
    },
    missing(){
      let missing = 0;
      for(let item of this.newInvoices.filter((element)=>element.send_missing==true && parseFloat(element.paid) < parseFloat(element.pending_amount))){
          missing+= parseFloat(item.pending_amount) - parseFloat(item.paid);
      }
      return missing;
    },
    final_total_to_pay(){
      return this.newInvoices.reduce((t, i) => t + parseFloat(i.paid || 0), 0);
    }
  },
  methods: {
    initializeOriginalValues() {
      for (var item of this.data) {
        if (!item.original_pending_amount) {
          item.original_pending_amount = item.pending_amount;
          item.original_total_paid = item.total_paid;
          item.original_total_to_pay = item.total_to_pay;
          item.original_currency_code = item.currency_code;
          item.original_currency_id = item.currency_id;
          item.paid_base_usd = item.paid || 0;
        }
      }
      this.newInvoices = [...this.data ];
      for(let key in this.newInvoices){
        this.$set(this.newInvoices[key], 'send_missing', false);
        this.$set(this.newInvoices[key], 'prepayment', undefined);
        this.newInvoices[key].missing_amount=0;
      }
    },
    updatePaidBase(item) {
      // Actualizar el valor base USD cuando el usuario modifica paid manualmente
      if (
        this.selectedCurrecies &&
        this.selectedCurrecies.code !== "USD" &&
        this.selectedCurrecies.id !== item.original_currency_id
      ) {
        // Si estamos en una moneda convertida, calcular el valor base USD
        const rate = item.currency_rate_new || 1;
        item.paid_base_usd = parseFloat(item.paid) / rate;
      } else {
        // Si estamos en USD, el valor paid es el valor base
        item.paid_base_usd = parseFloat(item.paid) || 0;
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    async save() {
      if(this.selectedPayments==null){
        this.$toast.warning("Debe seleccionar el metodo de pago.");
        return;
      }
      if(this.selectedAccontBank==null){
        this.$toast.warning("Debe seleccionar una cuenta de banco.");
        return;
      }
      if (!this.validate()) {
        return;
      }
      this.loadingSave = true;
      let payments = [];
      for (let item of this.data) {
        const paid = parseFloat(item.paid);
        if(paid>0){
          let excedente = paid-parseFloat(item.pending_amount);
          // Cuenta de banco del suplidor seleccionada para esta factura
          const supplierAccounts = this.supplierAccountsList[item.entity_id] || [];
          const selectedSupplierAccount = supplierAccounts.find(
            (a) => a.account_id === item.supplier_account_id
          ) || null;
          payments.push({
            entity_id: item.entity_id,
            invoice_id: item.invoice_id,
            payment_amount: paid>parseFloat(item.pending_amount)?parseFloat(item.pending_amount):paid,
            prepayment_id: item.prepayment ==undefined? null:item?.prepayment?.id,
            prepayment_amount: item.prepayment ==undefined? null:paid,
            excess_amount:excedente<=0?null:excedente,
            // La función guarda supplier_account_id (TEXT) en la columna SUPPLIER_ACCOUNT
            // (el número de cuenta) y supplier_bank_id en BANK_ID.
            supplier_account_id: selectedSupplierAccount ? selectedSupplierAccount.account : null,
            supplier_bank_id: selectedSupplierAccount ? selectedSupplierAccount.bank_id : null
          });
        }
      }
      const total_amount =this.data.reduce((sum, value) => sum + parseFloat(value.paid),0);
      const bank_comision=this.bank_comision!=null && this.bank_comision>0? this.bank_comision:null;
      if(bank_comision>=total_amount){
        this.$toast.warning("El monto de la comisión bancaria no puede ser mayor al monto total a pagar.");
        this.loadingSave = false;
        return;
      }
      const data = {
        in_payment_id: null,
        in_payment_type_id: this.selectedPayments,
        in_invoice_type_id: this.data[0].invoice_type_id,
        in_business_unit_id: this.data[0].business_unit_id,
        in_location_id: this.data[0].location_id,
        in_department_id: this.data[0].department_id,
        in_effective_date: this.datePay,
        in_account_date: this.dateAccount,
        in_created_by: this.$store.state.auth.user.user.user_id,
        in_bank_account_id: this.selectedAccontBank,
        in_currency_id: this.selectedCurrecies.id,        
        in_total_amount: total_amount,
        in_storage_json: null,
        in_check_number: this.check_number,
        in_invoice_payments: payments,
        in_entity_payments: {
            excess_amount:this.surplus>0?this.surplus:null,
            excess_chart_of_account_id:this.surplus>0?this.chart_of_account_id:null,
            note:this.note,
            currency_rate: 1/this.currency_rate,
            bank_comision: bank_comision,
        },
      };
      let response = await this.api_Post("transactions/save_pay", data);
      if (response.status == 200) {
        let datas = await response.json();

        let route = this.$router.resolve({
          name: this.type == 1 ? "ViewPaymentsCxP" : "ViewPaymentsCxC",
          params: { id: datas[0].id },
        });
        window.open(route.href);
        this.$emit("close");
      }
      this.loadingSave = false;
    },
    async updatePriceCurrency() {
      this.loading = true;

      // Asegurar que los valores originales estén inicializados
      this.initializeOriginalValues();

      for (var item of this.data) {
        // Si volvemos a la moneda original (USD), restaurar valores originales

        if (this.selectedCurrecies.id === item.original_currency_id) {
          item.pending_amount = item.original_pending_amount || 0;
          item.total_paid = item.original_total_paid || 0;
          item.total_to_pay = item.original_total_to_pay || 0;
          item.currency_code = this.selectedCurrecies.code;
          item.currency_rate_new = 1;
          // Restaurar el valor base ingresado por el usuario
          item.paid = item.paid_base_usd || 0;
          this.currency_rate=1;
        } else {
          // Convertir a otra moneda
          let data = {
            business_unit_id: this.data[0].business_unit_id,
            effective_date: this.dateAccount,
            currency_invoice_id: item.original_currency_id,
            currency_to: this.selectedCurrecies.id,
          };

          let response = await this.api_Post("accounting/currenciesByInvoice", data);
          if (response.status == 200) {
            let datas = await response.json();
            let rate = datas.length > 0 ? parseFloat(datas[0].value) : 1;
            this.currency_rate=rate;
            // Convertir valores usando la tasa de cambio (excepto total_amount que se mantiene original)
            item.pending_amount = parseFloat(item.original_pending_amount || 0) * rate;
           // item.total_paid = parseFloat(item.original_total_paid || 0) * rate;
            item.total_to_pay = parseFloat(item.original_total_to_pay || 0) * rate;
            item.currency_code = this.selectedCurrecies.code;
            item.currency_rate_new = rate;

            // Convertir el valor paid desde el valor base USD
            item.paid = (item.paid_base_usd || 0) * rate;
          }
        }
      }
      this.get_prepayments();
      // Actualizar la lista mostrada
      this.newInvoices = [...this.data];
      this.selectedAccontBank = null;
      this.loading = false;
    },
    set_new_currency_rate(){
        for (var item of this.data) {
            item.pending_amount = parseFloat(item.original_pending_amount || 0) * this.currency_rate;
          //  item.total_paid = parseFloat(item.original_total_paid || 0) * this.currency_rate;
            item.total_to_pay = parseFloat(item.original_total_to_pay || 0) * this.currency_rate;
            item.currency_code = this.selectedCurrecies.code;
            item.currency_rate_new = this.currency_rate;
            item.paid = (item.paid_base_usd || 0) * this.currency_rate; 
      }
      // Actualizar la lista mostrada
      this.newInvoices = [...this.data];
    },
    async getData() {
      this.loading = true;
     // let resultTypeCategories = await this.api_Get("accounting/categories_diary_book");
      let resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      const dataTypeAccounts = await resultTypeAccounts.json();
      for (let item of dataTypeAccounts) {
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }
      let business = await this.g_bussines();
      const data = await this.api_Get("income/payments_types");
      this.payments = await data.json();
      this.dates_accounting.start_date = "";
      this.dates_accounting.end_date = "";
      let request_calendar = {
        business_unit: this.data[0].business_unit_id,
        module: this.type == 1 ? 3 : 2,
      };
      const request = await this.api_Post(
        "accounting/get_calendar_accounting",
        request_calendar
      );
      if (request.status == 200) {
        const data = await request.json();
        if (data.length > 0) {
          this.dates_accounting.start_date = moment(data[0].from_date).format(
            "YYYY-MM-DD"
          );
          this.dates_accounting.end_date = moment(data[0].to_date).format("YYYY-MM-DD");
          this.dateAccount =moment().format("YYYY-MM-DD"); //moment(data[0].from_date).format("YYYY-MM-DD");
        }
      }
      let datas = await business.filter(
        (element) => element.id == this.data[0].business_unit_id
      );

      for (let item of datas[0].business_unit_accounts) {
        this.accountBank.push({
          account_id: item.account_id,
          account_name: item.account_name,
          account_type_id: item.account_type_id,
          account_type_description: item.account_type_description,
          account_bank_id: item.account_bank_id,
          bank_description_long: item.bank_description_long,
          account_check_digit: item.account_check_digit,
          currency_id: item.currency_id,
          currency_description: item.currency_description,
          text: item.bank_description_long + " ( Cta. " + item.account_check_digit + " )",
          chart_of_account_id: item.chart_of_account_id,
        });
      }
      this.getCurrencies();

      const uniqueEntityIds = [...new Set(this.data.map((i) => i.entity_id))];
      await Promise.all(uniqueEntityIds.map((id) => this.fetchSupplierAccount(id)));

      this.loading = false;
    },
    async fetchSupplierAccount(entity_id) {
      // Trae TODAS las cuentas del suplidor (para elegir a cuál pagar cada factura).
      const response = await this.api_Get("shopping/supplier_accounts/" + entity_id);
      if (response.status !== 200) return;
      const rows = await response.json();
      this.$set(this.supplierAccountsList, entity_id, rows);

      // La default (o la primera) se usa para el ícono y como preselección.
      const def = rows.find((r) => r.is_default) || rows[0] || null;
      this.$set(this.supplierAccounts, entity_id, def);

      // Preselecciona la cuenta default en cada factura de este suplidor.
      // Se asigna sobre this.data (fuente y mismas referencias que newInvoices);
      // newInvoices puede no estar poblado aún cuando corre este fetch.
      if (def) {
        const lists = [this.data || [], this.newInvoices || []];
        for (const list of lists) {
          for (const inv of list) {
            if (inv.entity_id === entity_id && inv.supplier_account_id == null) {
              this.$set(inv, "supplier_account_id", def.account_id);
            }
          }
        }
      }
    },
    async refreshAllSupplierAccounts() {
      this.loadingSuppliers = true;
      const uniqueEntityIds = [...new Set(this.newInvoices.map((i) => i.entity_id))];
      await Promise.all(uniqueEntityIds.map((id) => this.fetchSupplierAccount(id)));
      const missing = uniqueEntityIds.filter((id) => !this.supplierAccounts[id]);
      if (missing.length > 0) {
        this.$toast.warning(`${missing.length} suplidor(es) aún sin cuenta de banco registrada.`);
      } else {
        this.$toast.success("Todos los suplidores tienen cuenta de banco registrada.");
      }
      this.loadingSuppliers = false;
    },
    getAmountCurrency(invoice) {
      let amount = 0;

      let pendiente =
        parseFloat(invoice.total_amount) -
        (invoice.total_paid_amount == null ? 0 : invoice.total_paid_amount) *
          parseFloat(invoice.currency_rate_new);

      return parseFloat(parseFloat(pendiente));
      if (currencieSelected.code == "USD" && currencieItem == "USD") {
        amount = parseFloat(parseFloat(paid));
      }
      if (currencieSelected.code == "USD" && currencieItem == "DOP") {
        let datas = this.currencies.filter((element) => element.code === currencieItem);
        amount = parseFloat(parseFloat(paid) / datas[0].value);
      }

      if (currencieSelected.code == "HTG" && currencieItem == "DOP") {
        let datas = this.currencies.filter((element) => element.code === currencieItem);
        amount = parseFloat(parseFloat(paid) * datas[0].value);
      }
      if (currencieSelected.code == "HTG" && currencieItem == "USD") {
        amount = parseFloat(parseFloat(paid) * data[0].value);
      }

      if (currencieSelected.code == "DOP" && currencieItem == "USD") {
        amount = parseFloat(parseFloat(paid) * parseFloat(data[0].value));
      }

      if (currencieSelected.code == "DOP" && currencieItem == "DOP") {
        amount = parseFloat(parseFloat(paid));
      }

      return amount.toFixed(2);
    },
    async getCurrencies(val) {
      this.selectedCurrecies = null;
      const resultCurrencies = await this.api_Post("accounting/currenciesBusiness", {
        business: this.data[0].business_unit_id,

        effective_date: this.dateAccount,
      });
      this.currencies = await resultCurrencies.json();
    },
    async get_prepayments(){
      this.headers[6].align=' d-none';
        for(let key in this.newInvoices){
          this.newInvoices[key].paid=parseFloat(this.newInvoices[key].pending_amount);
        }
      if(this.selectedPayments!=12) return;
      if(!this.selectedCurrecies) return;
      this.headers[6].align='end';

      try {
        const response = await this.api_Post("transactions/get_prepayments", {
          business_unit_id: this.data[0].business_unit_id,
          location_id: this.data[0].location_id,
          invoice_type_id: this.type ,
          entity_id: this.data[0].entity_id,
          currency_id: this.selectedCurrecies.id
        });
        if (response.status != 200) {
          this.$toast.error("Error al obtener los pagos anticipados. "+response.message);
          return
        }
        const datas = await response.json();
        if(datas.length==0){
          this.$toast.info("No se encontraron pagos anticipados para este cliente en la moneda seleccionada.");
          this.selectedPayments=null;
          return;
        }
        this.prepayments = await datas;
        this.clear_payments();
      } catch (error) {
        console.error(error.message);
      }
    },
    clear_payments(){
       for(let key in this.newInvoices){
          this.$set(this.newInvoices[key], 'prepayment', undefined);
          this.$set(this.newInvoices[key], 'paid', 0);
        }
    },
    removeFromList(item) {
      this.newInvoices = this.newInvoices.filter(i => i !== item);
      this.$emit('remove-invoice', item);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
   asing_prepayment(invoice, prepayment) {
      const index = this.newInvoices.findIndex((line) => line === invoice);
      this.$set(this.newInvoices[index], 'prepayment', prepayment);
      let amount_to_pay = parseFloat(prepayment.total_amount)>parseFloat(invoice.pending_amount)?parseFloat(invoice.pending_amount):parseFloat(prepayment.total_amount);
      this.$set(this.newInvoices[index], 'paid', amount_to_pay);
    },
    apply_prepayment_to_all(prepayment) {
      if (!prepayment || prepayment.total_amount <= 0) return;
      this.clear_payments();
      let remaining = parseFloat(prepayment.total_amount);
      for (let i = 0; i < this.newInvoices.length; i++) {
        if (remaining <= 0) break;
        const invoice = this.newInvoices[i];
        const pending = parseFloat(invoice.pending_amount);
        const amount_to_pay = Math.min(remaining, pending);
        this.$set(this.newInvoices[i], 'prepayment', prepayment);
        this.$set(this.newInvoices[i], 'paid', amount_to_pay);
        remaining -= amount_to_pay;
      }
      this.$toast.success(`Prepago aplicado a ${this.newInvoices.filter(i => i.paid > 0).length} facturas.`);
    },
    getAmountColor(amount) {
      if (amount > 100) return 'green--text';
      if (amount > 20) return 'yellow--text';
      return 'red--text';
    },
    disabled_paid_prepayment(invoice){
      if(this.selectedPayments!=12){
        return false
      }
      if(invoice.prepayment!=undefined){
        return false
      }
      return true
    },
    max_amount_to_pay(invoice){
      if(this.selectedPayments!=12){
        return 99999999999999;
      }
      if(invoice.prepayment==undefined){
        return 99999999999999;
      }
      return parseFloat(invoice.prepayment.total_amount)>parseFloat(invoice.pending_amount)?parseFloat(invoice.pending_amount):parseFloat(invoice.prepayment.total_amount);
    },
    change_amount_paid(invoice){
       if(this.selectedPayments!=12){
        return;
      }
      const index = this.newInvoices.findIndex((line) => line === invoice);
      this.validate_prepayment_amounts(index);

      for(let key in this.newInvoices){
        if(key==index) continue;
        this.validate_prepayment_amounts(key);
      }
    },
    validate_prepayment_amounts(key){
        if(this.newInvoices[key].prepayment!=undefined ){
          const set_amount = this.newInvoices[key].prepayment?.total_amount>parseFloat(this.newInvoices[key].pending_amount)?parseFloat(this.newInvoices[key].pending_amount):parseFloat(this.newInvoices[key].prepayment.total_amount);;
          if(this.newInvoices[key].paid>this.newInvoices[key].prepayment.total_amount ){
              this.newInvoices[key].paid = set_amount
              this.$toast.warning("El monto excede el disponible del prepago!");
              return
            }
          if(this.newInvoices[key].paid>parseFloat(this.newInvoices[key].pending_amount)){
              this.newInvoices[key].paid = set_amount;
              this.$toast.warning("El monto excede el monto pendiente!");
              return
            }
        }
          const prepayment=this.prepayments_computed.find((element)=>element.id==this.newInvoices[key].prepayment?.id);
          if(prepayment!=undefined && prepayment.total_amount<0){
             this.$toast.warning("El monto excede el disponible del prepago!");
             this.newInvoices[key].paid= parseFloat(this.newInvoices[key].paid) + parseFloat(prepayment.total_amount);
              return
          }
    },
    get_missing_amount(item){
      const missing = parseFloat(item.pending_amount)-parseFloat(item.paid);
      return missing>0?missing:0;
    },
  },
};
</script>

<style scoped>
.lista-transacciones {
  list-style: none; /* Elimina los puntos de lista por defecto */
  padding: 0;
  width: 100%;
  max-width: 600px; /* Ajusta el ancho máximo según necesites */
  margin: 0 auto; /* Centra la lista */
}

.item-transaccion {
  display: flex; /* Usa Flexbox para alinear los elementos */
  justify-content: space-between; /* Coloca la descripción a la izquierda y el monto a la derecha */
  align-items: flex-start; /* Alinea los elementos en la parte superior */
  padding: 15px; /* Espacio interno para cada ítem */
  border-bottom: 1px solid #eee; /* Línea divisoria entre ítems */
}

.info-izquierda {
  flex-grow: 1; /* Permite que el lado izquierdo ocupe el espacio disponible */
  padding-right: 20px; /* Espacio entre la descripción y el monto */
}

.descripcion {
  margin: 0 0 5px 0; /* Espacio para la descripción */
  font-weight: bold;
}

.fecha {
  font-size: 0.8em; /* Tamaño de fuente más pequeño para la fecha */
  color: #888; /* Color gris para la fecha */
}

.info-derecha {
  display: flex;
  align-items: center;
}

.monto {
  font-weight: bold;
  font-size: 1.2em;
  color: green;
}

.prepayment-chip {
  cursor: pointer;
  transition: all 0.2s;
}
.prepayment-chip:hover {
  opacity: 0.85;
}

.prepayment-dropdown {
  border-radius: 8px !important;
  overflow: hidden;
}

.prepayment-item {
  transition: background-color 0.15s;
}
.prepayment-item:hover {
  background-color: #f5f5f5;
}
.prepayment-item--active {
  background-color: #e8f5e9 !important;
}

.settings-dropdown {
  border-radius: 8px !important;
  overflow: hidden;
}

.settings-delete-item {
  transition: background-color 0.15s;
}
.settings-delete-item:hover:not(.v-list-item--disabled) {
  background-color: #fef2f2 !important;
}
</style>
